module.exports = __webpack_public_path__ + "media/images/favicon-16x16-aa5b6746a834b7d47dcd3c5648d3b60c.png";